// services/astro-bot-miniapp/src/lib/onboarding-steps.ts

/**
 * Server-side onboarding step values (mirror of `User.onboardingStep` Int).
 * Step 5 intentionally omitted — selfie intro/capture are client-only nav from step 4.
 * See spec: docs/superpowers/specs/2026-05-20-p1.5a-onboarding-cleanup-design.md (state machine).
 */
export const ONBOARDING_STEPS = {
  SPLASH: 0,
  AGE_GATE: 1,
  BIRTH_DATA: 2,
  CHART_PENDING: 3,
  PERSONA_PICK: 4,
  SELFIE_PENDING: 6,
  PERSONAL_PICK_READY: 7,
  PERSONAL_PICKED: 8,
  PUSH_CONSENT_PENDING: 9,
  DONE: 99,
} as const;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[keyof typeof ONBOARDING_STEPS];

/**
 * Server-step → frontend route. Used by RootRedirect to resume the
 * correct screen on Mini App refresh. P1.5a sets up the contract;
 * the routes themselves are added in P1.5b (computing/pick) and
 * P1.5c (selfie/capture/adding/personal).
 */
export const STEP_TO_ROUTE: Record<number, string> = {
  // Step 0 → the Splash screen route. Must NOT be '/': RootRedirect lives at
  // '/' and returns null, so mapping step 0 to '/' makes a brand-new user
  // (onboardingStep 0) land on a no-op redirect to the same path and see a
  // blank/black screen forever. Point at the real splash route instead.
  0: '/onboarding/splash',
  1: '/onboarding/age',
  2: '/onboarding/birth',
  3: '/onboarding/computing',
  4: '/onboarding/info-reveal',
  6: '/onboarding/adding',
  7: '/onboarding/personal',
  8: '/onboarding/push',
  9: '/onboarding/push',
  99: '/home',
};
